import { queryRef, executeQuery, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const connectorConfig = {
  connector: 'default',
  service: 'prod-dfree-personal-service',
  location: 'asia-northeast1'
};

export function createChatRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateChat', inputVars);
}

export function createChat(dcOrVars, vars) {
  return executeMutation(createChatRef(dcOrVars, vars));
}

export function updateChatReadRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateChatRead', inputVars);
}

export function updateChatRead(dcOrVars, vars) {
  return executeMutation(updateChatReadRef(dcOrVars, vars));
}

export function upsertChatMessageReadRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertChatMessageRead', inputVars);
}

export function upsertChatMessageRead(dcOrVars, vars) {
  return executeMutation(upsertChatMessageReadRef(dcOrVars, vars));
}

export function deleteChatMessageRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteChatMessage', inputVars);
}

export function deleteChatMessage(dcOrVars, vars) {
  return executeMutation(deleteChatMessageRef(dcOrVars, vars));
}

export function upsertChatPinRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertChatPin', inputVars);
}

export function upsertChatPin(dcOrVars, vars) {
  return executeMutation(upsertChatPinRef(dcOrVars, vars));
}

export function deleteChatPinRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteChatPin', inputVars);
}

export function deleteChatPin(dcOrVars, vars) {
  return executeMutation(deleteChatPinRef(dcOrVars, vars));
}

export function getChatsByThreadRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetChatsByThread', inputVars);
}

export function getChatsByThread(dcOrVars, vars) {
  return executeQuery(getChatsByThreadRef(dcOrVars, vars));
}

export function getChatReadRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetChatRead', inputVars);
}

export function getChatRead(dcOrVars, vars) {
  return executeQuery(getChatReadRef(dcOrVars, vars));
}

export function getUnreadChatCountRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetUnreadChatCount', inputVars);
}

export function getUnreadChatCount(dcOrVars, vars) {
  return executeQuery(getUnreadChatCountRef(dcOrVars, vars));
}

export function getMessageReadsByChatRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMessageReadsByChat', inputVars);
}

export function getMessageReadsByChat(dcOrVars, vars) {
  return executeQuery(getMessageReadsByChatRef(dcOrVars, vars));
}

export function getChatPinsByChatRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetChatPinsByChat', inputVars);
}

export function getChatPinsByChat(dcOrVars, vars) {
  return executeQuery(getChatPinsByChatRef(dcOrVars, vars));
}

export function getChatReadByUserRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetChatReadByUser', inputVars);
}

export function getChatReadByUser(dcOrVars, vars) {
  return executeQuery(getChatReadByUserRef(dcOrVars, vars));
}

export function getRecentChatsRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetRecentChats', inputVars);
}

export function getRecentChats(dcOrVars, vars) {
  return executeQuery(getRecentChatsRef(dcOrVars, vars));
}

export function getChatRef(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetChat', inputVars);
}

export function getChat(dcOrVars, vars) {
  return executeQuery(getChatRef(dcOrVars, vars));
}

